// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: var(--background-default);
}

.wrapper {
  padding: 24px 16px 0px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: transparent;
}
.wrapper .title {
  font-family: AppFontMedium;
  font-size: 20px;
  margin: 0;
  display: flex;
  align-items: center;
  color: var(--color-black);
  text-transform: uppercase;
  text-align: start;
  padding: 0px 0px 16px;
}
.wrapper ion-col {
  padding: 0;
}
.wrapper ion-col:not(:last-child) {
  margin-bottom: 6px;
}
.wrapper ion-col .img-col {
  margin: 0;
}
.wrapper ion-col .card-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: var(--outline-default);
  border-radius: var(--radius-default);
  height: 100%;
  padding: 8px;
}
.wrapper ion-col .card-item .default-img {
  height: 60px;
  width: 67%;
  --logo-color: var(--ion-color-primary);
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper ion-col .card-item .image-block {
  height: 100%;
  position: relative;
  margin-right: 16px;
  display: flex;
  align-content: center;
  justify-content: center;
  margin: -8px 0 -8px -8px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
}
.wrapper ion-col .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper ion-col .card-item .info-block-col {
  padding-inline: 5px;
}
.wrapper ion-col .card-item .info-block-col .info-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow: 1;
}
.wrapper ion-col .card-item .info-block-col .info-block .name {
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 19px;
  margin: 0 0 4px;
  display: flex;
  align-items: center;
  color: var(--color-black);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper ion-col .card-item .info-block-col .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  margin: 0;
  margin-top: 20px;
  text-align: center;
}
.wrapper ion-col .card-item .info-block-col .info-block .price {
  margin: auto 0 10px;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 21.8px;
  text-align: center;
  color: var(--color-grey);
}
.wrapper ion-col .card-item .button {
  background: #e6e6e6;
  height: 39px;
  width: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  font-family: AppFont;
  font-size: 14px;
  text-align: center;
  color: var(--color-black);
  border-radius: var(--radius-default);
}
.wrapper .selected .checkmark {
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  --icon-color: var(--ion-color-primary);
}
.wrapper .selected .card-item {
  border: 1px solid var(--color-black);
}
.wrapper .selected .card-item .button {
  --background: var(--ion-color-primary) !important;
  background: var(--background) !important;
  color: var(--ion-color-primary-contrast);
  font-size: 12px;
}

.content_block {
  width: 100%;
}

ion-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 16px 18px;
  box-shadow: 2px 0px 5px 0px rgba(0, 0, 0, 0.2509803922);
}
ion-footer ion-button {
  width: 100%;
  --background: transparent;
  color: var(--color-black) !important;
  border: 2px solid var(--color-black);
}
ion-footer ion-button.selected {
  --background: var(--ion-color-primary) !important;
  background: var(--background) !important;
  border: 2px solid var(--ion-color-primary);
  color: var(--ion-color-primary-contrast) !important;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: left;
  padding-top: 6px;
}

.checkmark {
  height: 18px;
  width: 18px;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,qCAAA;AADD;;AAIA;EACC,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;AADD;AAGC;EACC,0BAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,qBAAA;AAFF;AAIC;EACC,UAAA;AAFF;AAIE;EACC,kBAAA;AAFH;AAKE;EACC,SAAA;AAHH;AAME;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,oCAAA;EAEA,YAAA;EACA,YAAA;AALH;AAOG;EACC,YAAA;EACA,UAAA;EAEA,sCAAA;EACA,8BAAA;EACA,sBAAA;AANJ;AASG;EACC,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;AARJ;AAcI;EACC,WAAA;EACA,YAAA;AAZL;AAcI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAZL;AAgBG;EACC,mBAAA;AAdJ;AAgBI;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;AAdL;AAgBK;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EAEA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EAEA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAjBN;AAyBK;EACC,cAAA;EACA,gCAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAvBN;AAyBK;EACC,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EAEA,kBAAA;EACA,wBAAA;AAxBN;AA6BG;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;AA5BJ;AAkCE;EACC,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;AAhCH;AAmCE;EACC,oCAAA;AAjCH;AAmCG;EACC,iDAAA;EACA,wCAAA;EACA,wCAAA;EACA,eAAA;AAjCJ;;AAuCA;EACC,WAAA;AApCD;;AAsCA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,uDAAA;AAnCD;AAqCC;EACC,WAAA;EACA,yBAAA;EACA,oCAAA;EACA,oCAAA;AAnCF;AAqCE;EACC,iDAAA;EACA,wCAAA;EACA,0CAAA;EACA,mDAAA;AAnCH;;AAuCA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AApCD;;AAsCA;EACC,YAAA;EACA,WAAA;EACA,aAAA;AAnCD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tbackground: var(--background-default);\n}\n\n.wrapper {\n\tpadding: 24px 16px 0px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: transparent;\n\n\t.title {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 20px;\n\t\tmargin: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\n\t\ttext-align: start;\n\t\tpadding: 0px 0px 16px;\n\t}\n\tion-col {\n\t\tpadding: 0;\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\n\t\t.img-col {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.card-item {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground: white;\n\t\t\tborder: var(--outline-default);\n\t\t\tborder-radius: var(--radius-default);\n\n\t\t\theight: 100%;\n\t\t\tpadding: 8px;\n\n\t\t\t.default-img {\n\t\t\t\theight: 60px;\n\t\t\t\twidth: 67%;\n\n\t\t\t\t--logo-color: var(--ion-color-primary);\n\t\t\t\tobject-fit: contain !important;\n\t\t\t\tbackground-color: #fff;\n\t\t\t}\n\n\t\t\t.image-block {\n\t\t\t\theight: 100%;\n\t\t\t\t// aspect-ratio: 4 / 3;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-right: 16px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-content: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tmargin: -8px 0 -8px -8px;\n\n\t\t\t\t// &:has(.default_img) {\n\t\t\t\t// \tbackground-color: var(--ion-color-primary);\n\t\t\t\t// }\n\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\t\t\t\t.plus {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\tright: 10px;\n\t\t\t\t\theight: 32px;\n\t\t\t\t\twidth: 32px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info-block-col {\n\t\t\t\tpadding-inline: 5px;\n\n\t\t\t\t.info-block {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\tflex-grow: 1;\n\n\t\t\t\t\t.name {\n\t\t\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 19px;\n\t\t\t\t\t\t// letter-spacing: 0.01em;\n\t\t\t\t\t\tmargin: 0 0 4px;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tcolor: var(--color-black);\n\n\t\t\t\t\t\tword-break: break-word;\n\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\n\t\t\t\t\t\t// @include mobile {\n\t\t\t\t\t\t// \tfont-size: 13px;\n\t\t\t\t\t\t// \t// height: 32px;\n\t\t\t\t\t\t// \toverflow: hidden;\n\t\t\t\t\t\t// }\n\t\t\t\t\t}\n\t\t\t\t\t.deposit_text {\n\t\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\t\tcolor: var(--color-black);\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t}\n\t\t\t\t\t.price {\n\t\t\t\t\t\tmargin: auto 0 10px;\n\t\t\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tline-height: 21.8px;\n\t\t\t\t\t\t// letter-spacing: 0.01em;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\tcolor: var(--color-grey);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.button {\n\t\t\t\tbackground: #e6e6e6;\n\t\t\t\theight: 39px;\n\t\t\t\twidth: 84px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tflex-shrink: 0;\n\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 14px;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tborder-radius: var(--radius-default);\n\t\t\t}\n\t\t}\n\t}\n\n\t.selected {\n\t\t.checkmark {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tleft: 10px;\n\t\t\tz-index: 10;\n\t\t\t--icon-color: var(--ion-color-primary);\n\t\t}\n\n\t\t.card-item {\n\t\t\tborder: 1px solid var(--color-black);\n\n\t\t\t.button {\n\t\t\t\t--background: var(--ion-color-primary) !important;\n\t\t\t\tbackground: var(--background) !important;\n\t\t\t\tcolor: var(--ion-color-primary-contrast);\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.content_block {\n\twidth: 100%;\n}\nion-footer {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 16px 18px;\n\tbox-shadow: 2px 0px 5px 0px #00000040;\n\n\tion-button {\n\t\twidth: 100%;\n\t\t--background: transparent;\n\t\tcolor: var(--color-black) !important;\n\t\tborder: 2px solid var(--color-black);\n\n\t\t&.selected {\n\t\t\t--background: var(--ion-color-primary) !important;\n\t\t\tbackground: var(--background) !important;\n\t\t\tborder: 2px solid var(--ion-color-primary);\n\t\t\tcolor: var(--ion-color-primary-contrast) !important;\n\t\t}\n\t}\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: left;\n\tpadding-top: 6px;\n}\n.checkmark {\n\theight: 18px;\n\twidth: 18px;\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
